export function encodeObjectIntoURIQueryParam(queryParams) {
    if (!queryParams) {
        return '';
    }
    return Object.keys(queryParams)
        .map((queryParamKey) => {
        return encodeURIComponent(queryParamKey) + '=' + encodeURIComponent(queryParams[queryParamKey]);
    })
        .join('&');
}
export function createLink(unit, affiliateUnitPageMetadata) {
    return ddbEnricher(unit, affiliateUnitPageMetadata);
}
function ddbEnricher(unit, affiliateUnitPageMetadata) {
    let updatedLink = unit.link;
    if (unit.campaign === 'ddb') {
        const { cityId, articleId, userId, sessionId } = affiliateUnitPageMetadata;
        const utmTerm = userId === null ? sessionId + '_' + userId : sessionId;
        const queryParams = {
            utm_medium: 'affiliate_link',
            utm_source: 'fandom',
            utm_campaign: unit.category,
            utm_term: utmTerm,
            utm_content: cityId + '_' + articleId + '_' + userId + '_mediawiki_content',
            fandom_slot_id: 'mediawiki_content',
        };
        updatedLink = unit.link + '?' + encodeObjectIntoURIQueryParam(queryParams);
    }
    return updatedLink;
}
